const swUrl = `${process.env.PUBLIC_URL}/sw.js`;


// ======================================================
// Timers / State
// ======================================================

let autoUpdateTimer = null;
let hideUpdateTimer = null;

let updateNotification = null;

let updateFlowStarted = false;


// ======================================================
// Notification
// ======================================================

const invokeServiceWorkerUpdateFlow = async (registration) => {

    // ----------------------------------------------
    // منع تكرار نفس الـUpdate Flow
    // ----------------------------------------------

    if (updateFlowStarted) {
        return;
    }

    updateFlowStarted = true;


    console.log(
        '🟡 Service Worker update available'
    );


    localStorage.setItem(
        'updateServiceWorker',
        true
    );


    // ----------------------------------------------
    // إظهار زر التحديث فورًا
    // ----------------------------------------------

    window.dispatchEvent(
        new Event('serviceWorkerUpdate')
    );


    // ----------------------------------------------
    // Notification
    // ----------------------------------------------

    try {

        const perm =
            await Notification.requestPermission();

        if (perm === 'granted') {

            if (updateNotification) {
                updateNotification.close();
            }

            updateNotification =
                new Notification(
                    'KPS مدرسة الكوثر الخاصة',
                    {
                        body:
                            'توجد تحديثات متاحة للموقع .. سيتم التحديث تلقائيًا خلال 5 ثوانٍ !',
                        icon:
                            '/assets/images/logo-b.png',
                    }
                );


            updateNotification.addEventListener(
                'click',
                () => {

                    if (
                        registration.waiting &&
                        !isUpdateStarted()
                    ) {

                        skipWaitingNow(
                            registration
                        );
                    }
                }
            );
        }

    } catch (error) {

        console.log(
            'Notification permission error:',
            error
        );
    }


    // ----------------------------------------------
    // Auto Update بعد 5 ثوانٍ
    // ----------------------------------------------

    clearTimeout(
        autoUpdateTimer
    );


    autoUpdateTimer =
        setTimeout(() => {

            if (registration.waiting) {

                console.log(
                    '🟢 Auto SKIP_WAITING after 5 seconds'
                );

                skipWaitingNow(
                    registration
                );

            } else {

                console.log(
                    '⚠️ No waiting Service Worker after 5 seconds'
                );
            }

        }, 5000);
};


// ======================================================
// هل التحديث بدأ بالفعل؟
// ======================================================

const isUpdateStarted = () => {

    return (
        localStorage.getItem(
            'serviceWorkerUpdateStarted'
        ) === 'true'
    );
};


// ======================================================
// تنفيذ SKIP_WAITING
// ======================================================

const skipWaitingNow = (registration) => {

    if (!registration || !registration.waiting) {
        return;
    }


    // منع إرسال الرسالة أكثر من مرة
    if (isUpdateStarted()) {
        return;
    }


    localStorage.setItem(
        'serviceWorkerUpdateStarted',
        'true'
    );


    clearTimeout(
        autoUpdateTimer
    );


    console.log(
        '🟢 Sending SKIP_WAITING'
    );


    registration.waiting.postMessage(
        'SKIP_WAITING'
    );
};


// ======================================================
// زر التحديث
// ======================================================

const invokeButton = (registration) => {

    if (registration.waiting) {

        skipWaitingNow(
            registration
        );
    }
};


// ======================================================
// متابعة Service Worker
// ======================================================

const updateServiceWorker = (
    registration,
    status
) => {

    localStorage.setItem(
        'serverLoading',
        true
    );


    const handleInstallingWorker = (
        installingWorker
    ) => {

        if (!installingWorker) {
            return;
        }


        installingWorker.addEventListener(
            'statechange',
            () => {

                console.log(
                    'SW state:',
                    installingWorker.state
                );


                if (
                    installingWorker.state === 'installed' &&
                    registration.waiting
                ) {

                    if (
                        navigator.serviceWorker.controller
                    ) {

                        // ==================================
                        // يوجد SW قديم بالفعل
                        // ==================================

                        if (status) {

                            invokeServiceWorkerUpdateFlow(
                                registration
                            );

                        } else {

                            // الوضع اليدوي
                            window.dispatchEvent(
                                new Event(
                                    'serviceWorkerUpdate'
                                )
                            );

                            localStorage.setItem(
                                'updateServiceWorker',
                                true
                            );
                        }

                    } else {

                        // ==================================
                        // أول تثبيت
                        // ==================================

                        console.log(
                            'Service Worker initialized for the first time'
                        );


                        localStorage.setItem(
                            'serverLoading',
                            false
                        );


                        localStorage.setItem(
                            'updateServiceWorker',
                            false
                        );
                    }
                }
            }
        );
    };


    // ==========================================
    // SW يتم تثبيته بالفعل
    // ==========================================

    if (registration.installing) {

        handleInstallingWorker(
            registration.installing
        );
    }


    // ==========================================
    // اكتشاف SW جديد
    // ==========================================

    registration.addEventListener(
        'updatefound',
        () => {

            console.log(
                '🟡 Service Worker update found'
            );


            if (registration.installing) {

                handleInstallingWorker(
                    registration.installing
                );
            }
        }
    );


    // ==========================================
    // Controller Changed
    // ==========================================

    let refreshing = false;


    navigator.serviceWorker.addEventListener(
        'controllerchange',
        () => {

            console.log(
                '🟢 Service Worker controller changed'
            );


            if (refreshing) {
                return;
            }


            refreshing = true;


            // ======================================
            // إلغاء مؤقت الـ5 ثوانٍ
            // ======================================

            clearTimeout(
                autoUpdateTimer
            );


            // ======================================
            // تسجيل وقت نجاح التحديث
            // حتى نحافظ على حالة الزر بعد reload
            // ======================================

            localStorage.setItem(
                'serviceWorkerUpdatedAt',
                Date.now().toString()
            );


            localStorage.setItem(
                'updateServiceWorker',
                true
            );


            // ======================================
            // Reload
            // ======================================

            window.location.reload();
        }
    );
};


// ======================================================
// استعادة حالة التحديث بعد Reload
// ======================================================

const restoreUpdateAfterReload = () => {

    const updatedAt =
        Number(
            localStorage.getItem(
                'serviceWorkerUpdatedAt'
            )
        );


    if (!updatedAt) {
        return;
    }


    const elapsed =
        Date.now() - updatedAt;


    // ==========================================
    // ما زلنا داخل فترة الـ10 ثوانٍ
    // ==========================================

    if (elapsed < 10000) {

        console.log(
            `🟢 Update completed ${elapsed}ms ago`
        );


        localStorage.setItem(
            'updateServiceWorker',
            true
        );


        window.dispatchEvent(
            new Event(
                'serviceWorkerUpdate'
            )
        );


        clearTimeout(
            hideUpdateTimer
        );


        hideUpdateTimer =
            setTimeout(() => {

                hideUpdateUI();

            }, 10000 - elapsed);


    } else {

        // ==========================================
        // انتهت فترة الـ10 ثوانٍ
        // ==========================================

        hideUpdateUI();
    }
};


// ======================================================
// إخفاء UI التحديث
// ======================================================

const hideUpdateUI = async () => {

    try {

        const registration =
            await navigator.serviceWorker
                .getRegistration();


        // ==========================================
        // لو يوجد SW جديد waiting
        // لا نخفي زر التحديث
        // ==========================================

        if (
            registration &&
            registration.waiting
        ) {

            console.log(
                '🟡 Waiting SW exists - keep update UI'
            );

            localStorage.setItem(
                'updateServiceWorker',
                true
            );

            return;
        }


        // ==========================================
        // لا يوجد waiting
        // نخفي UI
        // ==========================================

        console.log(
            '🟢 No waiting SW - hide update UI'
        );


        localStorage.setItem(
            'updateServiceWorker',
            false
        );


        localStorage.removeItem(
            'serviceWorkerUpdatedAt'
        );


        localStorage.removeItem(
            'serviceWorkerUpdateStarted'
        );


        window.dispatchEvent(
            new Event(
                'serviceWorkerUpdateDone'
            )
        );


        if (updateNotification) {

            updateNotification.close();

            updateNotification = null;
        }


        updateFlowStarted = false;

    } catch (error) {

        console.error(
            'Error hiding update UI:',
            error
        );
    }
};


// ======================================================
// الوضع اليدوي
// ======================================================

const updateServiceWorkerButton = async () => {

    if (!('serviceWorker' in navigator)) {
        return;
    }


    const registration =
        await navigator.serviceWorker
            .register(swUrl)
            .catch(error => {

                console.error(
                    'Service worker registration failed:',
                    error
                );

            });


    if (!registration) {
        return;
    }


    if (registration.waiting) {

        invokeButton(
            registration
        );
    }


    updateServiceWorker(
        registration,
        false
    );
};


// ======================================================
// Export
// ======================================================

export {
    invokeServiceWorkerUpdateFlow,
    updateServiceWorker,
    updateServiceWorkerButton,
    restoreUpdateAfterReload,
};